export const uiColors = {
  green: "rgb(0, 102, 67)",
  yellow: "rgb(241, 156, 36)"
};

export const DATA_DIR_PREFIX = "data/";
